import { SKIRTING_BOARD_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { ISkirtingBoard } from "../../shared/interfaces/skirting-board/ISkirtingBoard";

export const SkirtingBoardService = {
  getAll: (params: IPagination) => requests.get(SKIRTING_BOARD_URL, params),
  create: (params: ISkirtingBoard) => requests.post(`${SKIRTING_BOARD_URL}`, params),
  getSingle: (id: number) => requests.get(`${SKIRTING_BOARD_URL}/${id}`),
  update: (params: ISkirtingBoard, id: number) =>
    requests.put(`${SKIRTING_BOARD_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${SKIRTING_BOARD_URL}/${id}`),
};
